import { ProjectManagerWorkerDataStructure, TaskManagerWorkerData } from "../../types/dashboard.types";
import { GET_DASHBOARD_OVERVIEW_DATA, GET_DASHBOARD_OVERVIEW_DATA_FAILURE, GET_DASHBOARD_OVERVIEW_DATA_SUCCESS, SET_DASHBOARD_FLAG, GET_USER_PROJECT_MANAGER_WORKER_DATA, GET_USER_PROJECT_MANAGER_WORKER_DATA_FAILURE, GET_USER_PROJECT_MANAGER_WORKER_DATA_SUCCESS } from "../storeTypes";
interface InitialState {
    allDataLoading: boolean,
    progressionLoading: boolean,
    dashboardData: any,
    graphData: any;
    UserProjectManagerWorkerData: ProjectManagerWorkerDataStructure;
    UserSalesRepresentativeData: ProjectManagerWorkerDataStructure;
    UserTaskManagerWorkerData: TaskManagerWorkerData | any;
    UserProjectManagerWorkerLoading: boolean;
    UserSalesRepresentativeLoading: boolean;
    UserTaskManagerWorkerLoading: boolean;
    chartLoading: Record<string, boolean>; // Granular loading states
    error: string;
    flag: string;
    allProjectsCount?: number;
    years?: string[] | number[];
}

const defaultDashboardData = {
    projectOverview: {
        approvedCountData: { total: 0, status: null, percentage: 0, difference: 0, allProjectCount: 0, diffPercentage: 0, lastYear: 0, thisYear: 0 },
        deliveredProjectsData: { total: 0, status: null, percentage: 0, difference: 0, allProjectCount: 0, diffPercentage: 0, lastYear: 0, thisYear: 0 },
        inProgressProjectsData: { total: 0, status: null, percentage: 0, difference: 0, allProjectCount: 0, diffPercentage: 0, lastYear: 0, thisYear: 0 },
        onHoldProjectsData: { total: 0, status: null, percentage: 0, difference: 0, allProjectCount: 0, diffPercentage: 0, lastYear: 0, thisYear: 0 },
    },
    approvedProject: { Residential: 0, Commercial: 0, Industrial: 0, "Mix-use": 0 },
    projectInsights: [
        {
            "name": "Mechanical",
            "done": 0,
            "inProgress": 0,
            "onHold": 0,
            "total": 0
        },
        {
            "name": "Electrical",
            "done": 0,
            "inProgress": 0,
            "onHold": 0,
            "total": 0
        },
        {
            "name": "Plumbing",
            "done": 0,
            "inProgress": 0,
            "onHold": 0,
            "total": 0
        },
        {
            "name": "Structural",
            "done": 0,
            "inProgress": 0,
            "onHold": 0,
            "total": 0
        },
        {
            "name": "FP",
            "done": 0,
            "inProgress": 0,
            "onHold": 0,
            "total": 0
        }
    ],
    tradesDistribution: {
        "Plumbing (Standard)": 0,
        "Electrical (Standard)": 0,
        "Mechanical (Standard)": 0,
        "Fire Sprinkler": 0,
        "Structural Design": 0
    },
    mapData: {},
    doneProjectBreakdown: {
        "mechanical": {
            "total": 0,
            "planCheck": 0,
            "revision": 0,
            "noComments": 0
        },
        "electrical": {
            "total": 0,
            "planCheck": 0,
            "revision": 0,
            "noComments": 0
        },
        "plumbing": {
            "total": 0,
            "planCheck": 0,
            "revision": 0,
            "noComments": 0
        },
        "structural": {
            "total": 0,
            "planCheck": 0,
            "revision": 0,
            "noComments": 0
        }
    }
};
const defaultTeamData = {
    workers: [],
    managers: [],
    totalTask: null,
    totalRemainingTime: null
};

const defaultTaskManagerWorkerData: TaskManagerWorkerData = {
    Mechanical: { ...defaultTeamData },
    Electrical: { ...defaultTeamData },
    Plumbing: { ...defaultTeamData },
    Structural: { ...defaultTeamData },
};

const initialState: InitialState = {
    allDataLoading: false,
    progressionLoading: false,
    dashboardData: defaultDashboardData,
    graphData: null,
    UserProjectManagerWorkerData: [],
    UserSalesRepresentativeData: [],
    UserTaskManagerWorkerData: defaultTaskManagerWorkerData,
    UserProjectManagerWorkerLoading: false,
    UserSalesRepresentativeLoading: false,
    UserTaskManagerWorkerLoading: false,
    chartLoading: {},
    error: "",
    flag: "all-data",
    allProjectsCount: 0,
    years: []
};



const DashboardData = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_DASHBOARD_FLAG:
            return {
                ...state,
                flag: action.payload,
            }
        case GET_DASHBOARD_OVERVIEW_DATA: {
            return {
                ...state,
                allDataLoading: state.flag === "dashboard-data" || state.flag === "all-data" || state.flag === "dashboard-trades-type-worker-manager" || state.flag === "dashboard-project-type-data" || state.flag === "dashboard-time-data" || state.flag === "dashboard-project-type-worker-manager",
                progressionLoading: state.flag === "graph-data" || state.flag === "all-data" || state.flag === "dashboard-trades-type-worker-manager" || state.flag === "dashboard-project-type-data",
                dashboardData: state.flag === "dashboard-data" ? {} : state.dashboardData,
                graphData: state.flag === "graph-data" ? {} : state.graphData
            };
        }
        case GET_DASHBOARD_OVERVIEW_DATA_SUCCESS: {
            let dashboardData = {
                projectOverview: action?.payload?.projectOverview ? action?.payload?.projectOverview : state.dashboardData?.projectOverview,
                mapData: action?.payload?.mapData ? action?.payload?.mapData : state.dashboardData?.mapData,
                approvedProject: action?.payload?.approvedProject ? action?.payload?.approvedProject : state.dashboardData?.approvedProject,
                projectInsights: action?.payload?.projectInsights ? action?.payload?.projectInsights : state.dashboardData?.projectInsights,
                tradesDistribution: action?.payload?.tradesDistribution ? action?.payload?.tradesDistribution : state.dashboardData?.tradesDistribution,
                doneProjectBreakdown: action?.payload?.doneProjectBreakdown ? action?.payload?.doneProjectBreakdown : state.dashboardData?.doneProjectBreakdown,
            }
            const graphData = action.payload?.projectProgressionOverTimeData?.graphData ? action.payload?.projectProgressionOverTimeData?.graphData : state.graphData
            return {
                ...state,
                dashboardData: dashboardData,
                graphData: graphData,
                allDataLoading: false,
                progressionLoading: false,
                allProjectsCount: action.payload?.projectProgressionOverTimeData?.totalCount,
                years: action.payload?.years,
                error: ""
            };
        }
        case GET_DASHBOARD_OVERVIEW_DATA_FAILURE: {
            return {
                ...state,
                allDataLoading: false,
                progressionLoading: false,
                error: action.payload.error,
                // If we have existing data, keep it? Or if it's the first load and it fails, show default? 
                // The requirement is "it should return data with values 0" implies we should probably show the zero state on error.
                dashboardData: state.dashboardData && Object.keys(state.dashboardData || {}).length > 0 ? state.dashboardData : defaultDashboardData,
                graphData: state.graphData || [],
                years: state.years
            };
        }
        case GET_USER_PROJECT_MANAGER_WORKER_DATA: {
            const chartKey = action.payload?.chartKey;
            return {
                ...state,
                UserProjectManagerWorkerLoading: !chartKey, // If no key, assume global loading
                UserSalesRepresentativeLoading: !chartKey,
                UserTaskManagerWorkerLoading: !chartKey,
                chartLoading: chartKey ? { ...state.chartLoading, [chartKey]: true } : { ...state.chartLoading, all: true }
            };
        }
        case GET_USER_PROJECT_MANAGER_WORKER_DATA_SUCCESS: {
            const chartKey = action.payload?.chartKey;
            const pmPayload = action?.payload?.projectManagerWorkerData;
            const salesRepPayload = action?.payload?.salesRepresentative;
            const taskPayload = action?.payload?.taskManagerWorkerData;

            let updatedPMData = [...state.UserProjectManagerWorkerData];
            let updatedSalesRepData = [...state.UserSalesRepresentativeData];
            let newTaskData = { ...state.UserTaskManagerWorkerData };

            if (pmPayload) {
                // Only update PM data if we are NOT specifically filtering a team
                if (!chartKey || (!chartKey.startsWith('team_') && chartKey !== 'sales')) {
                    updatedPMData = pmPayload;
                }
            }
            if (salesRepPayload) {
                // Only update Sales Rep data if we are NOT specifically filtering generic 'sales' or other teams
                if (!chartKey || (!chartKey.startsWith('team_') && chartKey !== 'pm')) {
                    updatedSalesRepData = salesRepPayload;
                }
            }

            if (taskPayload) {
                Object.keys(taskPayload).forEach(team => {
                    const existingTeam = state.UserTaskManagerWorkerData[team] || {};
                    const incomingTeam = taskPayload[team];

                    if (chartKey === 'pm' || chartKey === 'sales') {
                        // If we are filtering PM or Sales, don't update team data
                        return;
                    }

                    if (chartKey && chartKey.startsWith('team_')) {
                        // Targeted team update
                        if (chartKey === `team_${team}`) {
                            newTaskData[team] = {
                                ...existingTeam,
                                ...incomingTeam
                            };
                        }
                    } else {
                        // Global update or unspecified
                        newTaskData[team] = {
                            ...existingTeam,
                            ...incomingTeam
                        };
                    }
                });
            }

            return {
                ...state,
                UserProjectManagerWorkerData: updatedPMData,
                UserSalesRepresentativeData: updatedSalesRepData,
                UserTaskManagerWorkerData: newTaskData,
                UserProjectManagerWorkerLoading: false,
                UserSalesRepresentativeLoading: false,
                UserTaskManagerWorkerLoading: false,
                chartLoading: chartKey ? { ...state.chartLoading, [chartKey]: false } : {},
                error: ""
            };
        }
        case GET_USER_PROJECT_MANAGER_WORKER_DATA_FAILURE: {
            const chartKey = action.payload?.chartKey;
            const isTeamKey = chartKey?.startsWith('team_');
            const isPMKey = chartKey === 'pm';
            const isSalesKey = chartKey === 'salesRepresentative';
            return {
                ...state,
                UserProjectManagerWorkerLoading: false,
                UserSalesRepresentativeLoading: false,
                UserTaskManagerWorkerLoading: false,
                chartLoading: chartKey ? { ...state.chartLoading, [chartKey]: false } : {},
                error: action.payload.error,
                // Only wipe the data slice that failed; global failure (no chartKey) wipes all
                UserProjectManagerWorkerData: (!chartKey || isPMKey) ? [] : state.UserProjectManagerWorkerData,
                UserSalesRepresentativeData: (!chartKey || isSalesKey) ? [] : state.UserSalesRepresentativeData,
                UserTaskManagerWorkerData: (!chartKey || isTeamKey) ? defaultTaskManagerWorkerData : state.UserTaskManagerWorkerData,
            };
        }
        default: {
            return state;
        }
    }

}

export default DashboardData;